import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import QualityAssurance from "./components/pages/QualityAssurance";

const resources = {
  en: {
    translation: {
      siteName: "Site Name",
      siteDescription: "Site Description",
      contactEmail: "Contact Email",
      contactPhone: "Contact Phone",
      siteAddress: "Site Address",
      currency: "Currency",
      language: "Language",
      saveSettings: "Save Settings",
      settingsUpdate: "Settings Update",
      successMessage: "Settings saved successfully!",
      errorMessage: "Error saving settings. Please try again.",
      home: "Home",
      aboutUs: "AboutUs",
      products: "Products",
      purchaseRequest: "PurchaseRequest",
      QualityAssurance: "qualityAssurance",
      blogs: "Blogs",
      contactUs: "ContactUs",
      register: "Register",
      login: "Login",
      language: "Language",
      english: "English",
      amharic: "አማርኛ",
      title: "About Us",
      subtitle: "Excellence in Plumbing & Fittings",
      description: `
          <strong>AG Pipe and Fitting Technology</strong>, is a publicly owned manufacturing 
          company situated in the capital of Ethiopia's "Amhara" region, Bahir Dar city.
          The company manufactures high-quality HDPE, PPR, and UPVC pipe fittings to deliver 
          to the customer at a reasonable price. With a diverse range of products,
          the company produces over 600 types of pipe fittings for potable water distribution, 
          sewerage, and construction. In addition to pipe fittings, AG Pipe Fitting Technology PLC 
          also specializes in the production of jerry cans, paint buckets, fiber glass products, 
          stadium seats, and offers HDPE field welding services. The company’s wide range of 
          offerings ensures it meets the needs of various industries and customers with 
          high-quality solutions.
        `,
      title1: "Among AGPFT products:",
      description1: `
        <strong>FITTING PRODUCTS</strong>
        <ul>
          <li>HDPE-pipe fittings produced with injection machine with an outer diameter ranging from OD-32 to 355mm and PN 16</li>
          <li>HDPE-pipe fittings produced by fabrication based on customers' demand, outer diameter ranging from OD-32 to 355mm and PN-10, 16, 20, 25</li>
          <li>HDPE pipe and fitting welding services</li>
          <li>UPVC-pipe fittings with an outer diameter ranging from (OD) -50, 75, 110 &160 mm, all with PN-6.3</li>
          <li>PPR pipe fittings of outer diameter ranging from (OD-20-75 mm) all with PN-25</li>
        </ul>
        <strong>OTHER PLASTIC PRODUCTS</strong>
        <ul>
          <li>Buckets (different sizes)</li>
          <li>Jerry cans (10 and 20-liter)</li>
          <li>Stadium seats</li>
        </ul>
      `,
      Mission:"Mission",
      mission1:`Satisfying customer needs by producing and supplying quality pipe fittings and other
       related plastic products to national and regional continental markets.  `, 
       Vission:"Vission",
       Vission1:`Aspiring to see AGPFT PLC become one of the leading and competent
        plastic manufacturing industries in Africa in 2024-2031.`,

        Delivery:"Product delivery system of the company",
        Deliveries:`
  <li>delivers  products based on customer's demand & order  </li>
 <li> provides Cash sales as well as credit sales for loyal customers  </li>
 <li>	 has price discount sales for loyal customers  <li>
 <li>	we provide product and service warrantee </li>
 <li>	distributes its products through sales agent </li>
`,
coreValues:"Our Core Values",
satisfyingCustomers:"Satisfying Customers",
productQuality: "Product Quality & Reliability",
socialWelfare: "Social Welfare & Healthiness",
costEffectiveness: "Cost-Effectiveness",
commitmentOwnership: "Commitment & Ownership",
changePrinciples: "Technology and Innovation",

welcome: 'Welcome to AG Pipe Fitting Technology',
partner: 'Your trusted partner for quality pipe fittings and customer satisfaction.',
footer:"AG Pipe Fitting Technology PLC is a manufacturing company situated in Ethiopia , Amhara  region, Bahir Dar. The company manufactures high-quality HDPE, PPR, and UPVC pipe fittings to deliver to the customer at a reasonable price. It produces more than 600 types of pipe fittings for irrigation , potable water distribution, sewerage, and sanitary construction projects.",
    },
  },
  am: {
    translation: {
      siteName: "የመስሪያ ቦታ ስም",
      siteDescription: "የመስሪያ ቦታ መግለጫ",
      contactEmail: "ኢሜይል",
      contactPhone: "ስልክ",
      siteAddress: "አድራሻ",
      currency: "ምንዛሪ",
      language: "ቋንቋ",
      saveSettings: "ማስቀመጥ",
      settingsUpdate: "የቅንብሮች ማሻሻያ",
      successMessage: "በትክክል ተመዝግበዋል!",
      errorMessage: "ቅንብሮችን ማስቀመጥ አልተሳካም። እባኮትን እንደገና ይሞክሩ።",
      home: "መነሻ",
      aboutUs: "ስለ እኛ",
      products: "ምርቶች",
      purchaseRequest: "የግዥ መጠየቂያ",
      qualityAssurance:"ጥራትና ቁጥጥር",
      blogs: "ብሎግ",
      contactUs: "ያነጋግሩን",
      register: "መመዝገቢያ",
      login: "መግቢያ",
      language: "ቋንቋ",
      english: "English",
      amharic: "አማርኛ",
      title: "ኤጂ ፓይፕ ፊቲንግ ቴክኖሎጂ",
      subtitle: "ስለ ኩባያችን",
      description: `
        <strong>ኤጂ ፓይፕ ፊቲንግ ቴክኖሎጂ ኃላ. የተወሰነ የግል ኩባንያ በአማራ ክልል ባህርዳር ከተማ 
          በማኑፋክቸሪንግ ኢንዱስትሪ ዘርፍ ለመስኖ ፣ መጠጥ ዉሃ ፣ ህንጻ ግንባታና ፍሳሽ አገልግሎት የሚዉሉ የተለያዩ የፕላስቲክ ቧንቧ
         መገጣጠሚያና ተጓዳኝ የፕላስቲክ ምርቶችን በጥራትና በተመጣጣኝ ዋጋ ለገበያ በማቅርብ ላይ የሚገኝ የመንግስት የልማት ድርጅት ነዉ፡፡
      `,
      title1: "ኩባንያዉ የሚያቀርባቸዉ ምርትና አገልግሎቶች",
      description1: `
        <strong>ቧንቧ መገጣጠሚያዎች</strong>
        <ul>
          <li>በኢንጀክሽን ማሸን የሚመረቱ ልዩ ልዩ ኤችዲፒ ፊቲንጎችን መጠን ዙሪያዉ ከ 32- እስከ 355  PN 16</li>
          <li>በደንበኞች ጥያቄ ላይ ተመስርቶ ልዩ ልዩ በፋብሪኬሽን የሚመረቱ ልዩ ልዩ ኤችዲፒ ፊቲንጎችን መጠን ዙሪያዉ ከ 32- እስከ 355 PN-10, 16, 20, 25</li>
          <li>ልዩ ልዩ የዩፒቪሲ ፊቲንጎችን መጠነ ዙሪያቸዉ 50፣ 75 እና 110 PN-6.3</li>
          <li>ልዩ ልዩ የፒፒአር ፊቲንጎችን መጠነ ዙሪያቸዉ ከ20 እስከ 75 PN-25</li>
        </ul>
        <strong>ሌሎች የፕላስቲክ ምርቶች</strong>
        <ul>
          <li>ጀሪካን (የተለያየ መጠን)</li>
          <li>የቀለም ባልዲዎች (የተለያየ መጠን)</li>
          <li>ስታዲየም ወንበሮች</li>
        </ul>
      `,
      Mission:"ራዕይ ",
      mission1: `•	ኤጂ ፓይፕ ፊቲንግ ቴክኖሎጂ ኃ/የግ/ኩባንያ በ2023ዓም ከምስራቅ አፍሪካ ካሉት ተመሳሳይ ኩባንያዎች ዉስጥ 
       ተፎካካሪና መሪ  ኩባንያ ሆኖ ማየት ፤  `,
       Vission:"ተልዕኮ ",
       Vission1:`•	ኤጂ ፓይፕ ፊቲንግ ቴክኖሎጂ ኃ/የግ/ኩባንያ በ2023ዓም ከምስራቅ አፍሪካ ካሉት ተመሳሳይ ኩባንያዎች ዉስጥ 
        ተፎካካሪና መሪ  ኩባንያ ሆኖ ማየት ፤`,

        Delivery:"ኩባንያዉ ሽያጭ የሚያከናዉናቸዉ ሂደቶች",
       Deliveries: `
        <ul>
        <li>የተለያዩ ዓይነት ፓይፕ ፊቲንጎችን በደንበኞች ፍላጎት ላይ ተመስርቶ ማቅረብ </li>
        <li> ምርትና አገልግሎትን በካሽ ወይም በዱቤ ማቅረብ </li>
        <li>በተከታታይና በስፋት ግዥ ለሚፈጽሙ ደንበኞቻችን በተመጣጣኝ ዋጋ ማቅረብ </li>
        <li>ለምርትና አገልግሎቶቻችን ጥራት ዋስትና መስጠት </li>
        <li> ምርቶቻችንን በሽያጭ ወኪሎች አማካኝነት ተደራሽ ማድረግ </li>
        </ul>`,
        coreValues:"የኩባንያዉ እሴቶች ",
        satisfyingCustomers:"የደንበኛ እርካታ  ",
        productQuality: "የምርት ጥራት ",
        socialWelfare: "ዘላቂ አብሮነት ",
        costEffectiveness: "ተመጣጥጣኝ ዋጋ",
        commitmentOwnership: "ቁርጠኝነታችን",
        changePrinciples: "ፈጠራና ቴክኖሎጅ",
       

        footer:`ኤጂ ፓይፕ ፊቲንግ ቴክኖሎጂ ኃላ. የተወሰነ የግል ኩባንያ በአማራ ክልል  ባህርዳር ከተማ   በማኑፋክቸሪንግ ኢንዱስትሪ ዘርፍ ለመስኖ ፣ መጠጥ ዉሃ ፣ ህንጻ ግንባታና ፍሳሽ አገልግሎት የሚዉሉ የተለያዩ የፕላስቲክ ቧንቧ መገጣጠሚያና ተጓዳኝ የፕላስቲክ 
        ምርቶችን በጥራትና በተመጣጣኝ ዋጋ ለገበያ በማቅርብ  ላይ የሚገኝ የመንግስት የልማት ድርጅት ነዉ፡፡`,

        welcome: 'እንኳን ወደ ኤጅ ፓይፕ ፊቲንግ ቴክኖሎጅ በሰላም መጡ!!',
      partner: 'የምርት ጥራትና  የደንበኛ እርካታ ዋነኛ ትኩረታችን ነዉ ።',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
